import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 14,
	viewBox: "0 0 20 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.01643 7.59432C1.90294 7.41462 1.8462 7.32477 1.81443 7.18618C1.79057 7.08209 1.79057 6.91792 1.81443 6.81383C1.8462 6.67524 1.90294 6.58539 2.01643 6.40569C2.95427 4.92071 5.74583 1.16667 10 1.16667C14.2542 1.16667 17.0457 4.92071 17.9836 6.40569C18.0971 6.58539 18.1538 6.67524 18.1856 6.81383C18.2094 6.91792 18.2094 7.08209 18.1856 7.18618C18.1538 7.32477 18.0971 7.41462 17.9836 7.59432C17.0457 9.0793 14.2542 12.8333 10 12.8333C5.74583 12.8333 2.95427 9.0793 2.01643 7.59432Z",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 9.5C11.3807 9.5 12.5 8.38072 12.5 7C12.5 5.61929 11.3807 4.50001 10 4.50001C8.61929 4.50001 7.5 5.61929 7.5 7C7.5 8.38072 8.61929 9.5 10 9.5Z",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEye;
